import DGUploadFile from 'components/FormControls/UploadFile/DGUploadFile';
import fileResizer from 'helpers/fileResizer';
import React, { Component } from 'react';
import { Button, Divider, Header, Icon, Modal } from 'semantic-ui-react';
import { getServiceDetails, uploadServiceRequestImages } from 'services/Manager';
import fileUpload from '../../assets/images/newui/file-upload.png'
import DealsModalBidSection from './DealsModalBidSection';

import Lightbox from "react-awesome-lightbox";
// You need to import the CSS only once
import "react-awesome-lightbox/build/style.css";
import _ from 'lodash';

class DealDetailsModal extends Component {
    constructor(props) {
        super(props)
        this.state = {
            files: [],
            request: {},
            showUploadControls: true,
            selectedImage: '',
            uploadButtonLoading: false,
            lbImages: [],
            selectedLBImage: 0
        }
    }

    componentDidUpdate(prevProps) {
        

        if (prevProps.open != this.props.open && this.props.open === true) {
            getServiceDetails(this.props.singleBuyerRequestID, this.props.buyerID).then(({ data }) => {
                this.setState({ request: data[0], selectedImage: data[0].images.length ? data[0].images[0].URL : ''})
            })
        }
        
    }

    modalCloseHandler = () => {
        this.setState({ files: [], request: {}});
        this.props.closeHandler();
    }

    uploadHandler = async () => {
        this.setState({ showUploadControls: false, uploadButtonLoading: true })
        let formData = new FormData();
        await Promise.all(this.state.files.map(async (file) => {
            const compressedImage = await fileResizer.resizeImageBeforeUpload(file);
            formData.append('photos', compressedImage, file.name);
        }));

        formData.append('buyerID', this.props.buyerID);
        uploadServiceRequestImages(this.props.singleBuyerRequestID, formData).then(res => {
            if (res.status == 'success') {
                const images = [...this.state.request.images,
                ...this.state.files.map(file => ({ URL: URL.createObjectURL(file) }))];
                this.setState({
                    showUploadControls: true,
                    request: {
                        ...this.state.request,
                        images
                    },
                    files: [],
                    selectedImage: images[0].URL,
                    uploadButtonLoading: false
                })

            }
        });
    }

    imageSelectHandler = (url, imgIndex) => {
        this.setState({ selectedImage: url })

        const images = [...(this.state.request.images || [])];
        if(images && images.length > 0){
            let lbImages = [];
            lbImages = _.map(images, (img) => {
                return img.URL;
            });

            this.setState({lbImages: lbImages, selectedLBImage: imgIndex});
        }
    }

    fileUploadTemplate = <div className='deal-details-modal-file-upload'>
        <div className='deal-details-modal-file-upload-image'>
            <img src={fileUpload}></img>
        </div>
        <div className='deal-details-modal-file-upload-content'>
            Click or drop files here to add images
        </div>
    </div>


    render() {
        const { request } = this.state;
        const images = [...(request.images || [])];
        const availableSlot = this.props.maxImageCount - (request.images ? request.images.length : 0);
        return <React.Fragment>
         
         <Modal
            closeIcon
            open={this.props.open}
            className='deals-details-modal service-form-modal-container'
            onClose={this.modalCloseHandler.bind(this)}
        >
            <Header className='deals-details-modal-header' content={`${request.serviceName} (${this.props.singleBuyerRequestID})`} />
            <Modal.Content scrolling>
                <div className='deals-details-modal-container'>
                    <div className='deals-service-request-details'>
                        {/*<div className='deals-service-request-expiry-info'>
                            {request.bidExpirationDefinition}
                            <Icon name='clock outline' size='large' />
                        </div>*/}
                        {request.serviceFormData ? request.serviceFormData.formPages[0].sections.map(section => (
                            <div className='deals-service-request-form-details'>
                                <div className='deals-service-request-form-details-header'>{section.headerText}</div>
                                {section.type == 'radio' ?
                                    <div className='deals-service-request-form-details-content-full'>
                                        <p  >{section.fields.find(f => f.value == 'checked') ? section.fields.find(f => f.value == 'checked').name : 'N/A'}</p>
                                    </div> :
                                    section.type == 'notes' ?
                                        <div className='deals-service-request-form-details-content-full'>
                                            <p>{section.fields[0].value || '-'}</p>
                                        </div> :
                                        Array(Math.ceil(section.fields.length / 2)).fill(0).map((num, index) => (
                                            <div className='deals-service-request-form-details-content-full'>
                                                <div className='deals-service-request-form-details-content'>
                                                    <p>{section.fields[((index + 1) * 2) - 2].name}</p>
                                                    <h4>{section.type == 'multi' ? section.fields[((index + 1) * 2) - 2].value == 'checked' ? 'Yes' : 'No'
                                                        : section.fields[((index + 1) * 2) - 2].value || '-'}</h4>
                                                </div>
                                                { section.fields[((index + 1) * 2) - 1] ? <div className='deals-service-request-form-details-content'>
                                                    <p>{section.fields[((index + 1) * 2) - 1].name}</p>
                                                    <h4>{section.type == 'multi' ? section.fields[((index + 1) * 2) - 1].value == 'checked' ? 'Yes' : 'No'
                                                        : section.fields[((index + 1) * 2) - 1].value || '-'}</h4>
                                                </div> : ''}
                                            </div>
                                        ))}
                            </div>)
                        ) : ''}
                    </div>
                    <div className='deals-service-request-images'>
                        <div className='deals-service-request-images-heading'>Pictures</div>
                        {request.images && request.images.length ?
                            <>
                                <div className='deals-service-request-big-image'>
                                    <img src={this.state.selectedImage}  onClick={() => this.imageSelectHandler(this.state.selectedImage, this.state.selectedLBImage)}/>
                                </div>
                                {images.map((img, imgIndex) =>
                                    <div className='deals-service-request-small-image'>
                                        <img src={img.URL} onClick={() => this.imageSelectHandler(img.URL, imgIndex)} />
                                    </div>
                                )}
                            </> : <div className='deal-details-modal-no-images'> No Pictures found. </div>}
                            

                        {this.props.type != 'expiring' && this.state.showUploadControls && availableSlot > 0 && !this.state.request.isAccepted ? <><Divider />
                            <DGUploadFile
                                template={this.fileUploadTemplate}
                                onDrop={(files) => this.setState({ files: files })}
                                onRemove={(files) => this.setState({ files: files })}
                                fileType="images"
                                maxFileCount={availableSlot} minFileCount={0} />
                        </> : ''}
                        {this.state.files.length ? <Button loading={this.state.uploadButtonLoading} onClick={this.uploadHandler.bind(this)} className='details-modal-upload-button'>Upload</Button> : ''}
                        <DealsModalBidSection timezone={this.props.timezone} request={request} onBidAcceptance={this.props.onBidAcceptance} bids={this.props.bids} />
                    </div>
                </div>
            </Modal.Content>
        </Modal>
         
            {this.state.lbImages && this.state.lbImages.length > 0 &&
                <Lightbox images={this.state.lbImages} onClose={() => this.setState({ lbImages: []})} startIndex={this.state.selectedLBImage}></Lightbox>
            }
    </React.Fragment>
    }
}

export default DealDetailsModal;